module.exports = __webpack_public_path__ + "img/cube-outline.577f8b8d.svg";